import { useEffect } from "react";
import { useSelector } from "react-redux";
import { AR_MARKUP_VIEW, EXTRACT_TEXT_VIEW, MARKUP_VIEW, MEASUREMENT_VIEW } from "../constants/Constants";

const useBottomMenuClass = (showContainer = false) => {
    const { extractTextInprogress } = useSelector((state) => state.extractText);
    const { isParticipantDrawerOpen, isNotesDrawerOpen, isBookmarkOpen, isChatDrawerOpen } = useSelector((state) => state.commonReducer);
    const { markupInprogress, markupLiveStream, arMarkupLiveStream } = useSelector((state) => state.markup);
    const { measurementView } = useSelector((state) => state.measurement);

    useEffect(() => {
        const ACTION_MENU_HIGH_CLASS = "action-menu-high";
        const actionMenu = document.getElementById("call-action-menu");

        if (!actionMenu) return; // Early return for readability

        const isAllViewsOff =
            markupInprogress === MARKUP_VIEW.OFF_VIEW &&
            extractTextInprogress === EXTRACT_TEXT_VIEW.OFF_VIEW &&
            measurementView === MEASUREMENT_VIEW.OFF_VIEW &&
            arMarkupLiveStream === AR_MARKUP_VIEW.OFF_VIEW &&
            !markupLiveStream;

        const isAnyDrawerOpen = showContainer || isParticipantDrawerOpen || isNotesDrawerOpen || isBookmarkOpen || isChatDrawerOpen;

        if (isAllViewsOff) {
            isAnyDrawerOpen ? actionMenu.classList.add(ACTION_MENU_HIGH_CLASS) : actionMenu.classList.remove(ACTION_MENU_HIGH_CLASS);
        } else {
            actionMenu.classList.remove(ACTION_MENU_HIGH_CLASS);
            if (actionMenu?.classList?.contains("call-action-moremenu-open")) {
                actionMenu.classList.remove("call-action-moremenu-open");
            }
        }
    }, [
        showContainer,
        isParticipantDrawerOpen,
        isNotesDrawerOpen,
        isBookmarkOpen,
        isChatDrawerOpen,
        markupInprogress,
        extractTextInprogress,
        measurementView,
        arMarkupLiveStream,
        markupLiveStream,
    ]);
};

export default useBottomMenuClass;
